// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagDateSvg from '@rsuite/icon-font/lib/application/TagDate';
var TagDate = createSvgIcon({
  as: TagDateSvg,
  ariaLabel: 'tag date',
  category: 'application',
  displayName: 'TagDate'
});
export default TagDate;